import { ApplicationPurposeCodeEnum } from '../../../shared/constants/application-purpose-codes';

export class SubmitToEwaConstants {
    public static readonly allowedPurposesForMinimumHandover: ApplicationPurposeCodeEnum[] =
        [
            ApplicationPurposeCodeEnum.new,
            ApplicationPurposeCodeEnum.renewalOrModification,
            ApplicationPurposeCodeEnum.modification,
        ];

    public static readonly allowedPurposesForPublicSafetyCustomerHandover: ApplicationPurposeCodeEnum[] =
        [
            ApplicationPurposeCodeEnum.new,
            ApplicationPurposeCodeEnum.renewalOrModification,
            ApplicationPurposeCodeEnum.modification,
        ];

    public static readonly allowedPurposesForPublicSafetyEwaHandover: ApplicationPurposeCodeEnum[] =
        [
            ApplicationPurposeCodeEnum.new,
            ApplicationPurposeCodeEnum.renewalOrModification,
            ApplicationPurposeCodeEnum.modification,
        ];

    public static readonly allowedPurposesForAdvisorPublicSafetyHandover: ApplicationPurposeCodeEnum[] =
        [
            ApplicationPurposeCodeEnum.new,
            ApplicationPurposeCodeEnum.renewalOrModification,
            ApplicationPurposeCodeEnum.modification,
        ];

    public static readonly allowedPurposesForAdvisorPublicSafetySimpleHandover: ApplicationPurposeCodeEnum[] =
        [
            ApplicationPurposeCodeEnum.constructionNotification,
            ApplicationPurposeCodeEnum.renewalOnly,
        ];

    public static readonly allowedPurposesForCoordinationIndustrialBusinessHandover: ApplicationPurposeCodeEnum[] =
        [
            ApplicationPurposeCodeEnum.new,
            ApplicationPurposeCodeEnum.renewalOrModification,
            ApplicationPurposeCodeEnum.modification,
        ];

    public static readonly allowedPurposesForAdvisorIndustrialBusinessHandover: ApplicationPurposeCodeEnum[] =
        [
            ApplicationPurposeCodeEnum.new,
            ApplicationPurposeCodeEnum.renewalOrModification,
            ApplicationPurposeCodeEnum.modification,
            ApplicationPurposeCodeEnum.constructionNotification,
            ApplicationPurposeCodeEnum.renewalOnly,
        ];
}
